


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VueRouter, { RouteConfig, Route } from "vue-router";
import { vsSideBar, vsIcon, vsDivider, vsSpacer } from "vuesax";
import Helpers from "@/helpers/helper";
Vue.use(vsIcon);
Vue.use(vsDivider);
Vue.use(vsSpacer);
Vue.use(vsSideBar);
@Component({
  name: "sidebarItem"
})
export default class SidebarItem extends Vue {
  @Prop() readonly group!: RouteConfig;
  @Prop() readonly item!: RouteConfig;

  getItemName(key: any) {
    return Helpers.Filters.Translate(key);
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  get user() {
    return this.$store.state.user;
  }

  showItem(item: any) {
    if (this.user.disabled) {
      return false;
    }
    if (item.meta && item.meta.isAdminCenter) {
      return this.user.isAdminCenter;
    }

    if (item.meta && item.meta.isInvestigator) {
      return this.user.isInvestigator;
    }
    
    return (
      this.user.isAdmin ||
      !item.meta ||
      !item.meta.permissionValue ||
      this.user.permissions.some(
        (x: any) => x.permissionValue == item.meta.permissionValue
      )
    );
  }
  showParent(item: any) {
    return (
      this.user.isAdmin ||
      !item.meta ||
      !item.meta.permissionValues ||
      this.user.permissions.some((x: any) =>
        item.meta.permissionValues.some((y: any) => y == x.permissionValue)
      )
    );
  }

  showDivider(item: any) {
    return (
      this.user.isAdmin ||
      !item.meta ||
      !item.meta.permissionValues ||
      this.user.permissions.some((x: any) =>
        item.meta.permissionValues.some((y: any) => y == x.permissionValue)
      )
    );
  }
  // get getActive() {
  //   return (this.$parent as any).getActive;
  // }
  // setIndexActive(index: number) {
  //   return (this.$parent as any).setIndexActive(index);
  // }
  itemChildrenHasPath(path: string) {
    return (
      this.item &&
      this.item.children &&
      this.item.children.some(x => x.path === path)
    );
  }
  get hasCurrentRoute() {
    return this.itemChildrenHasPath(this.$router.currentRoute.path);
  }
  // @Watch("$route", { deep: true, immediate: true })
  // onRoute(value: Route) {
  //   if (this.itemChildrenHasPath(value.path)) {
  //     this.setIndexActive(value.meta.index || 1);
  //   }
  // }
}
